/**
 * ProtectedRoute — wraps any element that requires a logged-in user. If the
 * JWT is missing or expired we send the visitor to /login.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../services/api';

export default function ProtectedRoute({ children }) {
    const location = useLocation();
    if (!auth.isLoggedIn()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}
